export default __webpack_public_path__ + "static/media/atera.925db2dc.svg";